import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MegaphoneStateTrueNofiTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MegaphoneStateTrueNofiTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.4183 10.5757C15.7613 10.5757 13.6105 8.47264 13.4829 5.83666C11.9272 6.20524 10.1874 6.21663 10.1666 6.21663H6.33834C3.94605 6.21663 2 8.17103 2 10.573C2 12.9356 3.88565 14.8543 6.22415 14.9168V19.7653C6.22415 20.9978 7.22286 22 8.45041 22C9.67847 22 10.6772 20.9978 10.6772 19.7653V14.9616C11.5908 15.0286 13.4667 15.2123 14.5618 15.6422C16.0601 16.2289 19.0951 18.4326 19.1255 18.4546C19.1609 18.4807 19.1993 18.5017 19.2397 18.5177C19.4221 18.5888 19.6131 18.6239 19.8036 18.6239C20.1112 18.6239 20.4169 18.5317 20.6781 18.3525C21.1014 18.0622 21.3542 17.5816 21.3542 17.0669V9.59026C20.5305 10.2019 19.5215 10.5757 18.4183 10.5757Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4183 9.19233C20.3964 9.19233 22 7.58227 22 5.59617C22 3.61006 20.3964 2 18.4183 2C16.4402 2 14.8366 3.61006 14.8366 5.59617C14.8366 7.58227 16.4402 9.19233 18.4183 9.19233Z"
        fill="#FC3B26"
      />
    </svg>
  );
};

export default MegaphoneStateTrueNofiTrueIcon;
